<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true" size="lg">
        <div slot="modal-header" class="w-100 text-center">
            <b>{{$t('asset.esp.titleAppraiser')}}</b>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <form action="#" v-on:submit.prevent="signAppraiserReportEsp">
                                                <div class="form-group">
                                                    <label class="text-danger">{{message}}</label>
                                                    <label>{{$t('realEstate.appraiserReportEsp.field.selectEsp')}}</label>
                                                    <select class="form-control"
                                                            :style="{color: color}"
                                                            v-model="keyOwn"
                                                            @change="onAppraiserEspChange"
                                                    >
                                                        <option v-for="item in items" :value="item.text" :key="item.id">
                                                            {{item.text}}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label style="display: none">Текст для подписи</label>
                                                    <textarea
                                                            cols="30" rows="5"
                                                            class="form-control"
                                                            v-model="appraiserReportEspData.textForSign"
                                                            readonly
                                                    ></textarea>
                                                </div>
                                                <button class="all-btn" type="button" @click="sign">
                                                    Подписать
                                                </button>
                                                <div class="form-group">
                                                    <label>ID ключа: {{ appraiserReportEspData.keyId }}</label>
                                                    <input type="hidden" class="form-control"
                                                           v-model="appraiserReportEspData.keyId"/>
                                                </div>
                                                <div class="form-group">
                                                    <label>Подписанный документ PKCS#7</label>
                                                    <textarea
                                                            class="form-control"
                                                            name="" cols="30" rows="5"
                                                            v-model="appraiserReportEspData.pkcs7"
                                                            readonly
                                                    ></textarea>
                                                </div>
                                                <div class="form-group">
                                                    <button class="all-btn edit-btn" type="submit" v-if="isSignEsp">
                                                        <i v-if="isSubmitReport" class="fa fa-spinner fa-spin"></i>
                                                        Хисоботни ЭЦП оркали тасдиқлаш
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>

    import EIMZOClient from '@/shared/esp/vue-e-imzo-client'
    import dates from '@/shared/esp/esp-date-utils'

    import Vue from "vue";

    var EventBus = new Vue();

    let errorCAPIWS = 'Ошибка соединения с E-IMZO. Возможно у вас не установлен модуль E-IMZO или Браузер E-IMZO.';
    let errorBrowserWS = 'Браузер не поддерживает технологию WebSocket. Установите последнюю версию браузера.';
    let errorUpdateApp = 'ВНИМАНИЕ !!! Установите новую версию приложения E-IMZO или Браузера E-IMZO.<br /><a href="https://e-imzo.uz/main/downloads/" role="button">Скачать ПО E-IMZO</a>';
    let errorWrongPassword = 'Пароль неверный.';

    var appKey = function () {
        EIMZOClient.API_KEYS = [
            'app.baxolash.uz', '3AC3930CE533B56CCFDC1D99EC02B7C02C3747AE67AEED4055ECF7169FC0880A6E8CA3B68F8F3BB753DB8736E7ABF96BFA98267A1FCB988156894F0E13D6D35B',
            'localhost', '96D0C1491615C82B9A54D9989779DF825B690748224C2B04F500F370D51827CE2644D8D4A82C18184D73AB8530BB8ED537269603F61DB0D03D2104ABF789970B',
            '127.0.0.1', 'A7BCFA5D490B351BE0754130DF03A068F855DB4333D43921125B9CF2670EF6A40370C646B90401955E1F7BC9CDBF59CE0B2C5467D820BE189C845D0B79CFC96F',
            'null', 'E0A205EC4E7B78BBB56AFF83A733A1BB9FD39D562E67978CC5E7D73B0951DB1954595A20672A63332535E13CC6EC1E1FC8857BB09E0855D7E76E411B6FA16E9D'
            // 'dls.yt.uz', 'EDC1D4AB5B02066FB3FEB9382DE6A7F8CBD095E46474B07568BC44C8DAE27B3893E75B79280EA82A38AD42D10EA0D600E6CE7E89D1629221E4363E2D78650516'
        ];
    };

    var getContractEsp = function () {

        let EIMZO_MAJOR = 3;
        let EIMZO_MINOR = 37;

        appKey();

        EIMZOClient.checkVersion(function (major, minor) {
            let newVersion = EIMZO_MAJOR * 100 + EIMZO_MINOR;
            let installedVersion = parseInt(major) * 100 + parseInt(minor);
            if (installedVersion < newVersion) {
                uiUpdateApp();
            } else {
                EIMZOClient.installApiKeys(function () {
                    uiLoadKeys();
                }, function (e, r) {
                    if (r) {
                        uiShowMessage(r);
                    } else {
                        wsError(e);
                    }
                });
            }
        }, function (e, r) {
            if (r) {
                uiShowMessage(r);
            } else {
                uiNotLoaded(e);
            }
        });
    };

    var getSign = function (vo, data, keyId) {

        let pkcs7Data = '';
        let keyIdData = '';

        if (keyId) {
            EIMZOClient.createPkcs7(keyId, data, null, function (pkcs7) {
                pkcs7Data = pkcs7;
                EventBus.$emit('uiConfirmData', pkcs7Data, keyIdData);
            }, function (e, r) {
                if (r) {
                    if (r.indexOf("BadPaddingException") != -1) {
                        uiShowMessage(errorWrongPassword);
                    } else {
                        uiShowMessage(r);
                    }
                } else {
                    uiShowMessage(errorBrowserWS);
                }
                if (e) wsError(e);
            });
        } else {
            EIMZOClient.loadKey(vo, function (id) {
                keyIdData = id;
                EventBus.$emit('uiConfirmData', pkcs7Data, keyIdData);
                EIMZOClient.createPkcs7(id, data, null, function (pkcs7) {
                    pkcs7Data = pkcs7;
                    EventBus.$emit('uiConfirmData', pkcs7Data, keyIdData);
                }, function (e, r) {
                    if (r) {
                        if (r.indexOf("BadPaddingException") != -1) {
                            uiShowMessage(errorWrongPassword);
                        } else {
                            uiShowMessage(r);
                        }
                    } else {
                        EventBus.$emit('uiConfirmData', pkcs7Data, keyIdData);
                        uiShowMessage(errorBrowserWS);
                    }
                    if (e) wsError(e);
                });
            }, function (e, r) {
                if (r) {
                    if (r.indexOf("BadPaddingException") != -1) {
                        uiShowMessage(errorWrongPassword);
                    } else {
                        uiShowMessage(r);
                    }
                } else {
                    uiShowMessage(errorBrowserWS);
                }
                if (e) wsError(e);
            });
        }
    };

    var uiLoadKeys = function () {
        EIMZOClient.listAllUserKeys(function (o, i) {
            let itemId = "itm-" + o.serialNumber + "-" + i;
            return itemId;
        }, function (itemId, v) {
            return uiCreateItem(itemId, v);
        }, function (items) {
            uiFillCombo(items);
            uiLoaded();
        }, function () {
            uiShowMessage(errorCAPIWS);
        });
    };

    var uiFillCombo = function (items) {
        EventBus.$emit('uiFillCombo', items)
    };

    var uiCreateItem = function (itemId, vo) {
        var now = new Date();
        vo.expired = dates.compare(now, vo.validTo) > 0;
        var text;
        text = vo.CN + ", " + vo.O;
        if (!vo.expired) {
            console.log()
        } else {
            text = text + ' (срок истек)';
        }

        var data = {
            id: itemId,
            vo: vo,
            text: text
        }
        EventBus.$emit('uiCreateItem', data);
        return data;
    };

    var uiUpdateApp = function () {
        EventBus.$emit('uiUpdateApp', errorUpdateApp);
    };

    var uiShowMessage = function (message) {
        EventBus.$emit('uiShowMessage', message);
    };

    var wsError = function (e) {
        if (e) {
            uiShowMessage(errorCAPIWS + " : " + e);
        } else {
            uiShowMessage(errorBrowserWS);
        }
    };

    var uiNotLoaded = function (e) {
        if (e) {
            wsError(e);
        } else {
            uiShowMessage(errorBrowserWS);
        }
    };

    var uiLoaded = function () {
        EventBus.$emit('uiLoaded');
    };

    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

    export default {
        name: "NewRealEstateAppraiserReportEspModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                message: '',
                color: '',
                keyOwn: '',
                items: [],
                isSubmitReport: false,
                realEstate: {},
                realEstateId: null,
                appraiserReportEspData: {
                    evaluationId: null,
                    userId: null,
                    pkcs7: '',
                    comment: '',
                    textForSign: '',
                    keyId: ''
                }
            }
        },
        computed: {
            isSignEsp() {
                return this.appraiserReportEspData.keyId && this.appraiserReportEspData.pkcs7
                    && this.appraiserReportEspData.textForSign
            }
        },
        methods: {
            init() {
                const id = this.realEstateId;
                if (id && id > 0) {
                    this.$http.get('/real-estate/' + id)
                        .then(res => {
                            if (res.data) {
                                this.realEstate = res.data;
                            }
                        }, err => {
                            console.log(err)
                        });
                }
            },
            signEsp() {
                if (this.appraiserReportEspData.keyId && this.appraiserReportEspData.pkcs7
                    && this.appraiserReportEspData.textForSign) {

                    this.$http.post('/estate/esp/sign-appraiser-report-esp', this.appraiserReportEspData)
                        .then(res => {
                            if (res.data.status === 'FAIL') {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: res.data.message,
                                    type: 'warning'
                                });
                            } else if (res.data.status === 'SUCCESS') {
                                this.$swal({
                                    title: this.$root.$t('messages.realEstate.appraiserEspSuccess'),
                                    text: this.$root.$t('messages.realEstate.appraiserEspSuccessInfo'),
                                    type: 'success',
                                    showCancelButton: true,
                                    confirmButtonColor: '#78b414',
                                    confirmButtonText: 'Тасдиқлаш',
                                    cancelButtonText: 'Бекор қилиш'
                                }).then((result) => {
                                    if (result.value) {
                                        this.show = false;
                                        // this.$router.go(0)
                                    }
                                })
                            }
                            this.isSubmitReport = false;
                        }).catch((e) => {
                        console.log(e);
                        this.isSubmitReport = false;
                    })
                }
            },
            signAppraiserReportEsp() {
                this.isSubmitReport = true;
                this.changeStatus('Evaluated')
            },
            onAppraiserEspChange() {
                this.appraiserReportEspData.textForSign = '';
                this.appraiserReportEspData.pkcs7 = '';
                if (this.keyOwn !== '' && this.items && this.items.length > 0) {
                    let keyData = this.items.filter((option) => {
                        return option.text === this.keyOwn;
                    });

                    if (keyData.length > 0) {
                        let vo = keyData[0].vo;
                        let userInn = vo.TIN;
                        let userName = vo.CN;
                        this.appraiserReportEspData.textForSign = this.realEstate.textSignForDirectorReport + " Имзоловчи: "+ userInn + "-" + userName;
                        this.appraiserReportEspData.keyId = ''
                    }
                }
            },
            sign() {
                if (this.keyOwn !== '' && this.items && this.items.length > 0) {
                    let keyData = this.items.filter((option) => {
                        return option.text === this.keyOwn;
                    });

                    if (keyData.length > 0) {
                        let vo = keyData[0].vo;
                        let data = this.appraiserReportEspData.textForSign;
                        let keyId = this.appraiserReportEspData.keyId;
                        getSign(vo, data, keyId);
                    }
                }
            },
            AppLoad() {
                this.ContractEspLoad();
            },
            uiLoading() {
                this.message = 'Загрузка ...'
            },
            uiUpdateAppCont(message) {
                this.message = message;
            },
            uiCreateItemCont(item) {
                let now = new Date();
                item.vo.expired = dates.compare(now, item.vo.validTo) > 0;
                if (!item.vo.expired) {
                    console.log()
                } else {
                    this.color = 'gray';
                }
            },
            uiLoaded() {
                if (this.items && this.items.length > 0) {
                    this.message = ''
                }
            },
            uiShowMessage(message) {
                confirm(message);
            },
            ContractEspLoad() {
                this.uiLoading();
                getContractEsp();
            },
            uiFillCombo(items) {
                this.items = items;
            },
            cancel() {
                this.show = false;
                this.$router.go(0)
            },
            changeStatus(status) {
                this.$http.post('admin/new-real-estate/status', {
                    realEstateId: this.realEstateId,
                    status: status,
                }).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        this.signEsp();
                    } else {
                        this.isSubmitReport = false;
                        this.$swal({
                            title: this.$root.$t('messages.common.warning'),
                            text: res.data && res.data.message ? res.data.message : this.$root.$t('messages.realEstate.statusWarning'),
                            type: 'warning'
                        });
                    }
                });
            }
        },
        created() {
            this.$eventBus.$on('showRealEstateAppraiserEspModal', (realEstateId) => {
                if (realEstateId && realEstateId > 0) {
                    this.show = true;
                    this.realEstateId = realEstateId;
                    this.appraiserReportEspData.evaluationId = realEstateId;
                    this.init();
                    this.AppLoad();

                    EventBus.$on('uiCreateItem', (item) => {
                        this.uiCreateItemCont(item);
                    });

                    EventBus.$on('uiUpdateApp', (message) => {
                        this.uiUpdateAppCont(message);
                    });

                    EventBus.$on('uiLoaded', () => {
                        this.uiLoaded()
                    });

                    EventBus.$on('uiShowMessage', (message) => {
                        this.uiShowMessage(message)
                    });
                    EventBus.$on('uiConfirmData', (pkcs7Data, keyIdData) => {

                        this.appraiserReportEspData.keyId = keyIdData;
                        this.appraiserReportEspData.pkcs7 = pkcs7Data;

                    });

                    EventBus.$on('uiFillCombo', (items) => {
                        this.uiFillCombo(items)
                    });
                }
            });
        }
    }
</script>

<style scoped>

</style>